module.exports = __webpack_public_path__ + "img/plant-3-blurred.e80fcec.png";